/* ÉCLAT D'AZUR — comportements globaux (révélations, header, placeholders produit) */
(function () {
  'use strict';

  /* ---------- Révélation au scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ea-reveal:not([data-ea-obs])');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ea-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ea-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.setAttribute('data-ea-obs', '1'); io.observe(el); });
  }

  /* ---------- Header : état au scroll ---------- */
  function initHeader() {
    var h = document.querySelector('#header-component');
    if (!h) return;
    var onScroll = function () { h.classList.toggle('ea-scrolled', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Placeholders de marque pour les produits sans image ---------- */
  var MOTIF = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="500" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice">' +
    '<defs><linearGradient id="b" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0d2f52"/><stop offset="0.5" stop-color="#0a2340"/><stop offset="1" stop-color="#05162b"/></linearGradient>' +
    '<radialGradient id="s" cx="50%" cy="34%" r="52%"><stop offset="0" stop-color="#f7e9c8" stop-opacity="0.45"/><stop offset="0.4" stop-color="#e9c987" stop-opacity="0.12"/><stop offset="1" stop-color="#0a2340" stop-opacity="0"/></radialGradient>' +
    '<linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f4e3bd"/><stop offset="1" stop-color="#b8934e"/></linearGradient></defs>' +
    '<rect width="400" height="500" fill="url(#b)"/><rect width="400" height="500" fill="url(#s)"/>' +
    '<path d="M120 175 Q200 255 280 175" fill="none" stroke="url(#g)" stroke-width="3"/>' +
    '<circle cx="200" cy="300" r="46" fill="none" stroke="url(#g)" stroke-width="3.5"/>' +
    '<circle cx="200" cy="300" r="20" fill="#d9b978" opacity="0.5"/></svg>'
  );
  function paintPlaceholders(root) {
    var svgs = (root || document).querySelectorAll('svg.placeholder-svg:not([data-ea-ph]), .placeholder svg:not([data-ea-ph])');
    svgs.forEach(function (svg) {
      var host = svg.parentElement;
      if (!host) return;
      svg.setAttribute('data-ea-ph', '1');
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      svg.style.opacity = '0';
      var img = document.createElement('img');
      img.src = MOTIF;
      img.alt = '';
      img.setAttribute('data-ea-motif', '1');
      img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;';
      host.appendChild(img);
    });
  }

  function boot() {
    initReveal(document);
    initHeader();
    paintPlaceholders(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Ré-exécuter dans l'éditeur de thème et après chargements dynamiques */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); paintPlaceholders(e.target); });
  window.addEventListener('load', function () { paintPlaceholders(document); });
  window.EAReveal = initReveal;
})();
